export default {
  // 课程
  competitionCourseList: '/competition_course/list',
  competitionCourseListExport: '/competition_course/list-export',
  competitionCourseDetail: '/competition_course/detail',
  competitionCourseConfirm: '/competition_course/confirm',
  competitionCourseReject: '/competition_course/reject',
  competitionCourseDelete: '/competition_course/delete',

  // 课程大赛统计
  statisticCompetitionCourseAuthorAffiliation: '/statistic/competition-course-author-affiliation',
  statisticCompetitionCourseAuthorAffiliationList: '/statistic/competition-course-author-affiliation-list',
  statisticCompetitionCourse: '/statistic/competition-course',
  statisticCompetitionCourseUser: '/statistic/competition-course-user',
}